import React from 'react'
import TableContent from '../../components/TableContent'
const url = 'connector/emails-office365'
const item = 'Email Office365'
const items = 'Emails Office365'

const ConnectorEmailOffice365 = () => {
  return (
    <TableContent
      url={url}
      type={'connector-email-office365'}
      item={item}
      items={items}
    />
  )
}
export default ConnectorEmailOffice365
